var _path, _circle, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeroOrb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 292"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.327,
    d: "M394.836 42c0 79.995-64.725 144.836-144.558 144.836-79.834 0-144.559-64.841-144.559-144.836 0-79.995 64.725-144.836 144.559-144.836 79.833 0 144.558 64.84 144.558 144.836z",
    stroke: "#6D7B8E",
    strokeWidth: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.176,
    cx: 250,
    cy: 42,
    r: 248,
    stroke: "#6D7B8E",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-orb_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 240.843,
    cy: 41.722,
    r: 99.334,
    fill: "url(#hero-orb_svg__paint0_radial)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero-orb_svg__paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(51.438 79.448 209.076) scale(124.884)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495D78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101A2C"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-orb_svg__filter0_d",
    x: 41.509,
    y: -149.612,
    width: 398.668,
    height: 398.668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.72549 0 0 0 0 0.894118 0 0 0 0 0.890196 0 0 0 0.23432 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUwIiBoZWlnaHQ9IjI5MiIgdmlld0JveD0iMCAwIDI1MCAyOTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIG9wYWNpdHk9IjAuMzI3NDI3IiBkPSJNMzk0LjgzNiA0Mi4wMDAxQzM5NC44MzYgMTIxLjk5NSAzMzAuMTExIDE4Ni44MzYgMjUwLjI3OCAxODYuODM2QzE3MC40NDQgMTg2LjgzNiAxMDUuNzE5IDEyMS45OTUgMTA1LjcxOSA0Mi4wMDAxQzEwNS43MTkgLTM3Ljk5NTIgMTcwLjQ0NCAtMTAyLjgzNiAyNTAuMjc4IC0xMDIuODM2QzMzMC4xMTEgLTEwMi44MzYgMzk0LjgzNiAtMzcuOTk1MiAzOTQuODM2IDQyLjAwMDFaIiBzdHJva2U9IiM2RDdCOEUiIHN0cm9rZS13aWR0aD0iNSIvPgo8Y2lyY2xlIG9wYWNpdHk9IjAuMTc2MDg0IiBjeD0iMjUwIiBjeT0iNDIiIHI9IjI0OCIgc3Ryb2tlPSIjNkQ3QjhFIiBzdHJva2Utd2lkdGg9IjQiLz4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZCkiPgo8Y2lyY2xlIGN4PSIyNDAuODQzIiBjeT0iNDEuNzIyNSIgcj0iOTkuMzM0MSIgZmlsbD0idXJsKCNwYWludDBfcmFkaWFsKSIvPgo8L2c+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2QiIHg9IjQxLjUwOTMiIHk9Ii0xNDkuNjEyIiB3aWR0aD0iMzk4LjY2OCIgaGVpZ2h0PSIzOTguNjY4IiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUNvbG9yTWF0cml4IGluPSJTb3VyY2VBbHBoYSIgdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDEyNyAwIi8+CjxmZU9mZnNldCBkeT0iOCIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSI1MCIvPgo8ZmVDb2xvck1hdHJpeCB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwLjcyNTQ5IDAgMCAwIDAgMC44OTQxMTggMCAwIDAgMCAwLjg5MDE5NiAwIDAgMCAwLjIzNDMyIDAiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJlZmZlY3QxX2Ryb3BTaGFkb3ciLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2Ryb3BTaGFkb3ciIHJlc3VsdD0ic2hhcGUiLz4KPC9maWx0ZXI+CjxyYWRpYWxHcmFkaWVudCBpZD0icGFpbnQwX3JhZGlhbCIgY3g9IjAiIGN5PSIwIiByPSIxIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgZ3JhZGllbnRUcmFuc2Zvcm09InRyYW5zbGF0ZSgxOTMuNDA3IDE2LjYyMykgcm90YXRlKDUxLjQzOCkgc2NhbGUoMTI0Ljg4NCkiPgo8c3RvcCBzdG9wLWNvbG9yPSIjNDk1RDc4Ii8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzEwMUEyQyIvPgo8L3JhZGlhbEdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgHeroOrb as ReactComponent };